<template>
    <div class="page-content">
        <!--    页面标题 start -->
        <div v-web-title :data-title="$t('message.me.title')"></div>
        <!--    页面标题 end -->

        <div class="page-content">

            <Row type="flex" justify="center">
                <!--        侧边栏 start -->
                <i-col :lg="4">
                    <SideBar class="mobile-no-sidebar" />
                </i-col>
                <!--        侧边栏 end -->

                <i-col :xs="24" :md="24" :lg="12">
                    <div class="right-content">
                        <div class="header">
                            <div class="title">{{$t('message.me.profile')}}</div>
                        </div>
                        <div class="line line-wrapper"></div>
                        <div class="profile-block">
                            <div class="left">
                                <div class="member-card">
                                    <div class="title-line">
                                        <div class="logo">
                                            <img src="../../assets/logo.png" alt="">
                                        </div>
                                        <div class="name">{{$t('message.me.cardName')}}</div>
                                    </div>
                                    <div class="vip-card">VIP</div>
                                    <div class="id">ID: {{userInfo.email}}</div>
                                </div>
                            </div>

                            <div class="right">
                                <div class="item">
                                    <img class="user-avatar" src="../../assets/user-head.gif" alt="">
                                </div>
                                <div class="item">
                                    <div class="name">{{$t('message.me.name')}}:</div>
                                    <div class="value">{{$t('message.me.memberName')}}</div>
                                </div>
                                <div class="item">
                                    <div class="name">{{$t('message.me.memberRank')}}:</div>
                                    <div class="value">{{userInfo.grade_name}}</div>
                                </div>
<!--                                <div class="item">-->
<!--                                    <div class="name">Phone:</div>-->
<!--                                    <div class="value">+86 13007710001</div>-->
<!--                                </div>-->
                                <div class="item">
                                    <div class="name">{{$t('message.me.email')}}:</div>
                                    <div class="value">{{userInfo.email}}</div>
                                </div>
                            </div>
                        </div>

                        <div class="line line-wrapper"></div>

                        <div class="info-block">
                            <div class="info-wrapper" @click="jumpTo('/Integral')">
                                <div class="name">{{$t('message.me.score')}}</div>
                                <div class="value">{{userInfo.integral}}</div>
                                <div class="button-wrapper">
                                    <Button type="primary"><span class="button-text">{{$t('message.me.redeem')}}</span></Button>
                                </div>
                            </div>
                            <div class="col-line"></div>
                            <div class="info-wrapper" @click="jumpTo('/Order')">
                                <div class="name">{{$t('message.me.orders')}}</div>
                                <div class="value">{{orderList.length}}</div>
                                <div class="button-wrapper">
                                    <Button type="primary" @click="jumpTo('/Order')"><span class="button-text">{{$t('message.me.seeOrders')}}</span></Button>
                                </div>
                            </div>
                            <div class="col-line"></div>
                            <div class="info-wrapper" @click="jumpTo('/CouponList')">
                                <div class="name">{{$t('message.me.myCoupons')}}</div>
                                <div class="value">{{availableCoupons.length}}</div>
                                <div class="button-wrapper">
                                    <Button type="primary"><span class="button-text">{{$t('message.me.seeCoupons')}}</span></Button>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div class="mobile-user-feature">
                        <div class="line line-wrapper" />
                        <div class="feature-block" @click="jumpTo('/Guest')">
                            <div class="name">{{$t('message.me.editGuests')}}</div>
                            <Icon class="feature-icon" type="ios-arrow-forward" size="20" color="#b2b2b2" />
                        </div>
                        <div class="line line-wrapper" />
                        <div class="feature-block" @click="jumpTo('/Feedback')">
                            <div class="name">{{$t('message.me.advices')}}</div>
                            <Icon class="feature-icon" type="ios-arrow-forward" size="20" color="#b2b2b2" />
                        </div>
                        <div class="line line-wrapper" />
                        <div class="feature-block" @click="showChangePasswordModal">
                            <div class="name">{{$t('message.me.changePassword')}}</div>
                            <Icon class="feature-icon" type="ios-arrow-forward" size="20" color="#b2b2b2" />
                        </div>
                        <div class="line line-wrapper" />
                        <div class="feature-block" @click="showLogoutModal">
                            <div class="name">{{$t('message.me.logout')}}</div>
                            <Icon class="feature-icon" type="ios-arrow-forward" size="20" color="#b2b2b2" />
                        </div>
                        <div class="line line-wrapper" />
                    </div>

                    <!--        退出登录对话框 start -->
                    <Modal v-model="isShowLogoutModal" @on-ok="logout">
                        <div class="confirm-dialog">
                            <Icon type="md-help-circle" size="40" color="orange"/>
                            <p>{{$t('message.me.logoutModalText')}}</p>
                        </div>
                    </Modal>
                    <!--        退出登录对话框 end -->

                </i-col>


            </Row>

        </div>

        <ChangePassword :is-show="isShowChangePasswordModal" @changeShowStatus="changePasswordShowStatus" />

    </div>
</template>

<script>
  import SideBar from "../../components/SideBar/SideBar.vue";
  import {gotoPage, logout, urlRequest} from "../../common/common";
  import moment from "moment";
  import {mapMutations} from "vuex";
  import ChangePassword from "../../components/changePassword/ChangePassword";

  export default {
    name: "me",

    data() {
      return {
        // 用户信息
        userInfo: {},
        // 可用房间优惠券数据
        availableCoupons: [],
        // 订单列表数据
        orderList: [],
        // 是否展示退出登录对话框
        isShowLogoutModal: false,
        // 是否展示修改密码对话框
        isShowChangePasswordModal: false,

      }
    },

    created() {

      // 从缓存读取用户信息
      this.userInfo = JSON.parse(localStorage.getItem('userInfo'));

      // 调用接口获取数据
      this.loadData();

    },

    methods: {

      ...mapMutations([
        // 修改登录状态
        'setLoginStatus',
        // 删除订单列表数据
        'delOrderList',
      ]),

      // 展示修改密码对话框
      showChangePasswordModal() {
        this.isShowChangePasswordModal = true;
      },
      // 修改密码对话框状态变化
      changePasswordShowStatus(val) {
        this.isShowChangePasswordModal = val;
      },

      // 页面跳转
      jumpTo(name) {
        gotoPage({
          path: name
        });
      },

      // 获取数据
      loadData() {

        // 可用房间优惠券数据
        urlRequest({
          url: this.api.getAvailableCouponList,
          method: 'POST',
        }).then(res => {
          this.availableCoupons = res.data.msg.filter(item => {
            return item.room_type !== 0;
          });
          console.log('availableCoupons: ', this.availableCoupons);
        });

        // 获取订单列表数据
        urlRequest({
          url: this.api.getOrderList,
          method: 'POST',
        }).then(res => {
            this.orderList = res.data.msg.all;
        });

      },

      // 展示退出对话框
      showLogoutModal() {
        this.isShowLogoutModal = true;
      },

      // 退出登录
      logout() {
        logout();
      },

    },

    components: {
      ChangePassword,
      SideBar,
    }
  }
</script>

<style lang="scss" scoped>
    @import "@/assets/style/mainStyle.scss";
    @import "Me.scss";

</style>
